import { FormattedMessage } from 'react-intl';
import { FirstNameFieldContainer, LastNameFieldContainer } from './elements/NameField';
import { PersonalEmailContainer, PersonalPhoneNumberContainer } from './elements/PersonalElementContainers';
import { PersonalBackButton } from './elements/PersonalBackButton';
import { PersonalNextButton } from './elements/PersonalNextButton';
import { AccountInformation1, AccountInformation2 } from '../companyInfo/AccountInformation';

export const PersonalPage = () => {
    return (
        <div className={'RegistrationPanelContainer panel-default panel panel-body padding-25'}>
            <h2 className={'text-center margin-bottom-20'}>
                <FormattedMessage id={'intl-msg:registration.personalData.heading'} />
            </h2>
            <form className={'PersonalPageContainer'}>
                <div className={'row'}>
                    <FirstNameFieldContainer width={'col-sm-6 margin-bottom-10'} />
                    <LastNameFieldContainer width={'col-sm-6 margin-bottom-10'} />
                </div>
                <div className={'row'}>
                    <PersonalEmailContainer
                        width={'col-sm-6 margin-bottom-10'}
                        error={'intl-msg:registration.error.email.InvalidFormat'}
                        required
                    />
                    <PersonalPhoneNumberContainer width={'col-sm-6 margin-bottom-10'} required={false} />
                </div>
                <div className={'form-group col-xs-12 margin-top-10'}>
                    <AccountInformation1 />
                    <AccountInformation2 />
                </div>
                <hr />
                <div className={'display-flex justify-content-between margin-top-20-sm'}>
                    <PersonalBackButton isLoading={false} />
                    <PersonalNextButton />
                </div>
            </form>
        </div>
    );
};
